// Auto-generated by bump-version.ps1
export const APP_VERSION = "1.22.21";
export const BUILD_DATE = "2026-10-20";
